export default __webpack_public_path__ + "static/media/vusdc.ea4a1e03.png";